export default __webpack_public_path__ + "static/media/Vambraces of the Hell Walker (nm).ade1a8c5.jpg";